import mainBackground from "../assets/images/jpg/main-bg.jpg";
import caseStudiesBg from "../assets/images/jpg/bgn-case-studies.jpg";
export default {
  mainBackground,
  caseStudiesBg,
};
